import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type DrawerName =
  | 'class_topic_content'
  | 'notification_history'
  | 'class_sider'
  | 'menu_sider'
  | '';

export type State = {
  visible?: boolean;
  name?: DrawerName;
  extra?: any;
};

const initialState: State = {
  visible: false,
  name: '',
};

const { reducer, actions } = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    open(state, action: PayloadAction<State>) {
      state.visible = true;
      state.name = action.payload.name;
      state.extra = action.payload.extra;
    },
    close(state, action: PayloadAction<State>) {
      state.visible = false;
      state.name = action.payload ? action.payload.name : '';
    },
    toggle(state, action: PayloadAction<State | void>) {
      state.visible = !state.visible;
      state.name = action.payload ? action.payload.name : '';
    },
  },
});

export { reducer };
export default actions;
